import { jsx as _jsx } from "react/jsx-runtime";
import { Video } from './VideoPlayer.style';
export const VideoPlayer = ({ autoPlay = false, controls = true, crop, loop = false, muted = false, objectFit, src, }) => (_jsx(Video, { autoPlay: autoPlay, controls: controls, crop: crop, loop: loop, muted: muted, objectFit: objectFit, src: src }));
//# sourceMappingURL=VideoPlayer.js.map